const borderStyle = {
  borderColor: '#000000',
  borderStyle: 'thin'
}

const headerStyle = {
  ...borderStyle,
  align: 'center',
  alignVertical: 'center',
  backgroundColor: '#9CDCEA',
  fontWeight: 'bold',
  wrap: true
}

const warningHeaderStyle = {
  ...headerStyle,
  backgroundColor: '#9CDCEA',
  textColor: '#FF0000'
}

function createTitleRow(value, columnCount) {
  return [
    {
      value: String(value ?? ''),
      columnSpan: columnCount,
      fontSize: 16,
      fontWeight: 'bold'
    },
    ...Array(columnCount - 1).fill(null)
  ]
}

function buildReportSheet({
  data = [],
  organization,
  title,
  columns,
  sheetName,
  highlightedColumnIndexes = []
}) {
  const sheetData = [
    createTitleRow(organization, columns.length),
    createTitleRow(title, columns.length),
    Array(columns.length).fill(null),
    columns.map((column, index) => ({
      value: column.label,
      ...(highlightedColumnIndexes.includes(index)
        ? warningHeaderStyle
        : headerStyle)
    })),
    ...data.map((row) =>
      columns.map((column) => ({
        value: row[column.key] ?? ''
      }))
    )
  ]

  return {
    sheetData,
    sheetOptions: {
      sheet: sheetName
    }
  }
}

const birthdayColumns = [
  { key: 'num', label: '#' },
  { key: 'org', label: 'Org' },
  { key: 'code', label: 'Code' },
  { key: 'level', label: 'Level' },
  { key: 'date', label: 'Birthday' },
  { key: 'nameEn', label: 'Name (Eng)' },
  { key: 'surnameEn', label: 'Surname (Eng' },
  { key: 'nicknameEn', label: 'Nickname (Eng)' },
  { key: 'nameTh', label: 'Name (Th)' },
  { key: 'surnameTh', label: 'Surname (Th' },
  { key: 'nicknameTh', label: 'Nickname (Th)' },
  { key: 'division', label: 'Group' },
  { key: 'department', label: 'Department' },
  { key: 'type', label: 'Type' }
]

const appointmentColumns = [
  { key: 'num', label: 'ลำดับที่' },
  { key: 'code', label: 'รหัสพนักงาน' },
  { key: 'name', label: 'ชื่อ-นามสกุล' },
  { key: 'division', label: 'สายงาน' },
  { key: 'faction', label: 'ฝ่าย' },
  { key: 'department', label: 'แผนก' },
  { key: 'position', label: 'ตำแหน่ง' },
  {
    key: 'type',
    label: 'ประเภทพนักงาน (รายวัน/รายเดือน, Temporary/Permanent)'
  },
  { key: 'startDate', label: 'วันที่เริ่มงาน' },
  { key: 'empDate', label: 'วันที่บรรจุ' },
  { key: 'others', label: 'หมายเหตุ' }
]

const resignColumns = [
  { key: 'num', label: 'ลำดับที่' },
  { key: 'code', label: 'รหัสพนักงาน' },
  { key: 'name', label: 'ชื่อ-นามสกุล' },
  { key: 'position', label: 'ตำแหน่ง' },
  { key: 'division', label: 'สายงาน' },
  { key: 'faction', label: 'ฝ่าย' },
  { key: 'department', label: 'แผนก' },
  { key: 'lastDate', label: 'วันที่ทำงานวันสุดท้าย' },
  { key: 'endDate', label: 'วันที่มีผลสิ้นสุด' },
  { key: 'resign', label: 'สาเหตุการออก' },
  { key: 'others', label: 'หมายเหตุ' }
]

export function buildBirthdayReportSheet({
  data,
  organization,
  periodLabel
}) {
  return buildReportSheet({
    data,
    organization,
    title: `วันเกิดพนักงานประจำเดือน${periodLabel || '-'}`,
    columns: birthdayColumns,
    sheetName: 'Birthdays'
  })
}

export function buildAppointmentReportSheet({
  data,
  organization,
  periodLabel
}) {
  return buildReportSheet({
    data,
    organization,
    title: `พนักงานบรรจุ เดือน${periodLabel || '-'}`,
    columns: appointmentColumns,
    sheetName: 'Employment'
  })
}

export function buildResignReportSheet({
  data,
  organization,
  periodLabel
}) {
  return buildReportSheet({
    data,
    organization,
    title: `พนักงานลาออก เดือน${periodLabel || '-'}`,
    columns: resignColumns,
    sheetName: 'Resign Employees',
    highlightedColumnIndexes: [8]
  })
}
